export default defineNuxtPlugin((nuxtApp) => {

  // Also possible
  nuxtApp.hook('vue:error', async (error, instance, info) => {
    const message = error?.stack ? error.stack : String(error)
    const { $api } = useNuxtApp()
    try {
      await $api('/logging/', { method: 'POST', body: { name: 'frontend', level: 'error', message} })
    } finally {

    }
  })
})
